import React from 'react'
import Image from 'next/image'
import { trackExternalLink } from '../utils/gtag'
import kiwiTicketLogo from '../public/assets/images/kiwiticket_logo.svg'

const Footer = () => (
  <footer className="text-white bg-gray-800 relative py-8 mt-16 filter shadow-md">
    <div className="container mx-auto px-6">

      <div className="sm:flex sm:mt-8">
        <div className="mt-8 sm:mt-0 sm:w-full sm:px-8 flex flex-col md:flex-row justify-around">
          <div className="flex flex-col">
            <span className="font-bold text-gray-400 uppercase mt-4 md:mt-0">Privacy</span>
            <a href="https://info.kiwiticket.co.nz/privacy" onClick={() => trackExternalLink("https://info.kiwiticket.co.nz/privacy")} className="text-green hover:underline text-md hover:text-blue-500">Privacy Notice</a>
            <a href="https://info.kiwiticket.co.nz/terms-and-conditions" onClick={() => trackExternalLink("https://info.kiwiticket.co.nz/terms-and-conditions")} className="text-green hover:underline text-md hover:text-blue-500">Terms and Conditions</a>
          </div>
          <div className="flex flex-col">
            <span className="font-bold text-gray-400 uppercase mt-4 md:mt-0">Sell Tickets</span>
            <a href="https://info.kiwiticket.co.nz/fees" onClick={() => trackExternalLink("https://info.kiwiticket.co.nz/fees")} className="text-green hover:underline text-md hover:text-blue-500">Fees</a>
            <a href="mailto:help@kiwiticket.co.nz" onClick={() => trackExternalLink("mailto:help@kiwiticket.co.nz")} className="text-green hover:underline text-md hover:text-blue-500">Contact</a>
          </div>
        </div>
      </div>
    </div>
    <div className="container mx-auto">
      <div className="mt-8 flex flex-col items-center">
        <div className="sm:w-2/3 text-center py-6">
          <p className="text-sm font-bold mb-2 flex justify-center items-center">
            © 2021 by KiwiTicket
            <Image className="ml-2" src={kiwiTicketLogo} alt="KiwiTicket Logo" width={32} height={32} />
          </p>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
